<template>
    <slot v-if="flat" />
    <div v-else ref="groupRef" class="relative">
        <button type="button" class="px-2 text-sm text-gray-600" @click.stop="toggle">
            {{ label }}
            <ChevronDownIcon class="inline-block h-3 w-3" />
        </button>
        <div v-show="open" class="md:absolute md:top-full md:left-0 md:z-50 md:min-w-40 md:rounded-sm md:bg-white md:pt-2 md:pb-1 md:shadow-lg">
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
import { ref } from 'vue';

const activeGroup = ref<symbol | null>(null);
</script>

<script setup lang="ts">
import { ChevronDownIcon } from '@heroicons/vue/24/solid';
import { computed, onBeforeUnmount, onMounted } from 'vue';

defineProps<{
    label: string;
    flat?: boolean;
}>();

const id = Symbol();
const open = computed(() => activeGroup.value === id);
const groupRef = ref<HTMLElement | null>(null);

function toggle() {
    activeGroup.value = open.value ? null : id;
}

function onClickOutside(e: MouseEvent) {
    if (open.value && groupRef.value && !groupRef.value.contains(e.target as Node)) {
        activeGroup.value = null;
    }
}

onMounted(() => document.addEventListener('click', onClickOutside));
onBeforeUnmount(() => document.removeEventListener('click', onClickOutside));
</script>
